module.exports = __webpack_public_path__ + "img/27.f9532729.jpg";